import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { BaseEtiqueta } from '../custom-feature/types/base-etiqueta';
import { C, Cookies } from '@shared/commons';
import { CustomFeatureSectionDTO } from '@shared/dto/customFeatureSection.dto';
import { FuncionalidadPersonalizacion } from '@shared/models/funcionalidadPersonalizacion';
import { CustomPanelProvider } from '@shared/providers/customPanel.provider';
import { GeneralProvider } from '@shared/providers';
import { FuncionalidadPersonalizacionService } from '@shared/services/funcionalidad-personalizacion.service';
import { MessageService } from 'primeng';
import { EtiquetaViewModel } from '../custom-feature/types/etiqueta-view-model';

@Component({
  selector: 'app-custom-panel',
  templateUrl: './custom-panel.component.html',
  styleUrls: ['./custom-panel.component.scss']
})
export class CustomPanelComponent implements OnInit, AfterViewInit {
  @ViewChildren(BaseEtiqueta) etiquetas: QueryList<BaseEtiqueta>;
  @Input() funcionalidadPanelId: number;
  @Output() onGuardarPanelEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCerrarPanelEmitter: EventEmitter<any> = new EventEmitter<any>();

  customPanelSections: CustomFeatureSectionDTO[] = [];
  customPanelSectionsView: any = [];
  funcionalidadPersonalizadasPanel: FuncionalidadPersonalizacion[] = [];
  blocked: boolean = false;
  preFixEtiquetaHija: String = "_hijo";
  etiquetasLocales: any = []
  lenguage;

  constructor(
    private customPanelProvider: CustomPanelProvider,
    private general: GeneralProvider,
    private fpService: FuncionalidadPersonalizacionService,
    private messageService: MessageService
  ) {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.etiquetasLocales = JSON.parse(localStorage.getItem("etiquetas"));
    this.lenguage = Cookies.getCookie("LANGUAGE");
  }

  ngOnInit(): void {
    this.customPanelProvider.currentCustomPanelSections
      .subscribe((sections: CustomFeatureSectionDTO[]) => {
        this.customPanelSections = sections;
        this.mapToCustomPanelSectionsView();
        this.incluirPanelEtiquetasHijas();
      });

    this.customPanelProvider.currentfuncionalidadPersonalizadas
      .subscribe((options: FuncionalidadPersonalizacion[]) => this.funcionalidadPersonalizadasPanel = options);
  }

  ngAfterViewInit() {
    this.customPanelProvider.currentIsOpen
      .subscribe((isOpen: boolean) => {
        if (isOpen) {
          this.blocked = true;
          setTimeout(() => this.selectedOptions(), 500);
        }
      })
  }

  /*
  selectedOptions() {
    this.customPanelSectionsView = this.customPanelSectionsView.map(customFeatureSection => {
      const _customFeatureSection = { ...customFeatureSection };
      _customFeatureSection.etiquetas = _customFeatureSection.etiquetas.map(etiqueta => {
        const funcionalidadPersonalizadaPanelMatch = this.funcionalidadPersonalizadasPanel
          .find(funcionalidadPersonalizada => funcionalidadPersonalizada.etiqueta.etiquetaId === etiqueta.etiquetaId);
        etiqueta.nombre = this.lenguage == "en" ? etiqueta.nombreEn : etiqueta.nombre;
        if (funcionalidadPersonalizadaPanelMatch) {
          etiqueta.estado = funcionalidadPersonalizadaPanelMatch.estado;
          etiqueta.nombre = funcionalidadPersonalizadaPanelMatch.nombre;
          etiqueta.funcionalidadPersonalizacionId = funcionalidadPersonalizadaPanelMatch.funcionalidadPersonalizacionId;
        }
        return etiqueta;
      });

      return _customFeatureSection;
    })
    this.blocked = false;
  }
    */

  selectedOptions() {
  this.customPanelSectionsView = this.customPanelSectionsView.map(customFeatureSection => {
    const _customFeatureSection = { ...customFeatureSection };
    const isGrupoFiltros = _customFeatureSection.nombre === 'Filtros';

    _customFeatureSection.etiquetas = _customFeatureSection.etiquetas.map(etiqueta => {
      const funcionalidadPersonalizadaPanelMatch = this.funcionalidadPersonalizadasPanel
        .find(funcionalidadPersonalizada => funcionalidadPersonalizada.etiqueta.etiquetaId === etiqueta.etiquetaId);

      etiqueta.nombre = this.lenguage === "en" ? etiqueta.nombreEn : etiqueta.nombre;

      if (funcionalidadPersonalizadaPanelMatch) {
        if (funcionalidadPersonalizadaPanelMatch.estado === null || funcionalidadPersonalizadaPanelMatch.estado === undefined) {
          const defaultHidden = [
            "mapa_filter_tb_viaje_estado", 
            "mapa_filter_tb_viaje_placa", 
            "mapa_filter_tb_viaje_codigo", 
            "mapa_filter_tb_viaje_cod_exter"
          ];
          etiqueta.estado = !defaultHidden.includes(etiqueta.codigo);
        } else {
          etiqueta.estado = funcionalidadPersonalizadaPanelMatch.estado;
        }
        
        etiqueta.nombre = funcionalidadPersonalizadaPanelMatch.nombre;
        etiqueta.funcionalidadPersonalizacionId = funcionalidadPersonalizadaPanelMatch.funcionalidadPersonalizacionId;
      } else {
        const defaultHidden = [
          "mapa_filter_tb_viaje_estado", 
          "mapa_filter_tb_viaje_placa", 
          "mapa_filter_tb_viaje_codigo", 
          "mapa_filter_tb_viaje_cod_exter"
        ];
        etiqueta.estado = !defaultHidden.includes(etiqueta.codigo);
      }

      return etiqueta;
    });

    return _customFeatureSection;
  });

  this.blocked = false;
}


  saveOptionsPanel() {
    if (!this.blocked) {
      this.blocked = true;
      const funcionalidadesPersonalizadasActualizadas = this.etiquetas.map(etiqueta => etiqueta.obtenerFuncionalidadPersonalizacion());

      this.fpService.guardar({
        opciones: funcionalidadesPersonalizadasActualizadas
      }).subscribe(r => {
        this.showToast('success', '', r.mensaje);
      },
        error => {
          this.showToast('error', '', error.mensaje);
          this.closeOptionsPanelEmitter();
        },
        () => this.saveOptionsPanelEmitter());
    }
  }

  closeOptionsPanelEmitter() {
    this.blocked = false;
    this.onCerrarPanelEmitter.emit();
  }

  saveOptionsPanelEmitter() {
    this.blocked = false;
    this.onGuardarPanelEmitter.emit();
  }

  private showToast(severidad: string, titulo: string, detalle: string) {
    this.messageService.add({ severity: severidad, summary: titulo, detail: detalle });
  }
  private mapToCustomPanelSectionsView(): void {
    this.customPanelSectionsView = this.customPanelSections.map(customPanelSection => {
      const _customPanelSection = {
        ...customPanelSection
      } as any;

      _customPanelSection.etiquetas = customPanelSection.etiquetas.map(etiqueta => ({
        ...etiqueta
      }) as EtiquetaViewModel);

      return _customPanelSection;
    });
  }

  private incluirPanelEtiquetasHijas(): void {
    const etiquetas = (this.customPanelSectionsView as any).flatMap(customPanelSection => customPanelSection.etiquetas);

    // listado de etiquetas que contienen el prefijo para identificar etiquetas hijas
    const etiquetasHijas = etiquetas.filter(etiqueta => etiqueta.codigo.includes(this.preFixEtiquetaHija));

    this.customPanelSectionsView.forEach(customPanelSection => {
      etiquetasHijas.forEach(etiquetaHija => {
        customPanelSection.etiquetas.find(etiqueta => {

          if (etiqueta.codigo === etiquetaHija.codigo.split(this.preFixEtiquetaHija)[0]) {
            etiqueta.etiquetaHija = etiquetaHija;
          }
        })
      })
    });
  }
}
